// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__ZlfMv","flash":"styles_flash__eJHyQ","counter":"styles_counter__XB9+l","icon":"styles_icon__Enn1X","text":"styles_text__rCKcD"};